import { StyleSheet } from 'react-native';

import { C } from '../../../../common';
import { LAYOUT } from '../../../../reactor/common';

export default StyleSheet.create({
  centered: {
    flexDirection: 'column',
    alignItems: 'center',
  },

  container: {
    ...C.PAGE_CONTENT,
    ...LAYOUT.STYLE.ROW,
    alignItems: 'flex-start',
  },

  content: {
    maxWidth: '75%',
  },

  contentCentered: {
    textAlign: 'center',
  },

  number: {
    opacity: 0.75,
  },
});
